<template>
    <div>
        <!-- formulario de asistencia -->

        <v-form ref="formDatos" lazy-validation>
            <v-dialog
                v-model="modalParticipacion"
                persistent
                scrollable
                max-width="75%"
            >
                <v-card>
                    <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-0">
                            PARTICIPACIÓN DEL ESTUDIANTE

                            <v-chip :color="datosClase.color_nivel">
                                <span class="px-0 white--text font-weight-black"
                                    >Nivel: {{ datosClase.desc_nivel }}  |  Grado:
                                    {{ datosClase.desc_grado }}  |  Sección:
                                    {{ datosClase.nombre_seccion }}</span
                                >
                            </v-chip>

                            <v-btn
                                fab
                                dark
                                x-small
                                class="btn_style3"
                                @click="$emit('close')"
                                ><v-icon dark>fa-times</v-icon></v-btn
                            >
                        </v-row>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>
                        <!-- {{datosProgDocente}} -->
                        <!-- {{AlumnosSeccion}} -->
                        <!-- {{asistencia}} -->

                        <v-row>
                            <v-col cols="12" class="d-flex justify-center pt-0">
                                <p class="body-1 mb-0 black--text">
                                    <span class="font-weight-black"
                                        >Unidad:
                                    </span>
                                    {{ datosClase.nombre_tema }} -
                                    <span class="font-weight-black"
                                        >Tema:
                                    </span>
                                    {{ datosClase.nombre_clase }}
                                </p>
                            </v-col>
                        </v-row>

                        <!--
                                {{parametrosAsistencia}}   
                                {{AlumnosSeccion}}
                            -->

                        <v-row>
                            <v-col cols="12" class="py-0">
                                <h3 class="font-weight-black black--text">
                                    Lista de estudiantes:
                                </h3>

                                <v-data-table
                                    :headers="headers"
                                    :items="AlumnosSeccion"
                                    :sort-by="['nombre_persona']"
                                    :sort-desc="[false]"
                                    class="elevation-1 black--text"
                                    :disable-pagination="true"
                                    :hide-default-footer="true"
                                    :fixed-header="true"
                                    :height="680"
                                >
                                    <template v-slot:item.puntuacion="{ item }">
                                        <v-rating
                                            :value="rating[item.id]"
                                            background-color="orange lighten-3"
                                            color="orange"
                                            length="5"
                                            size="15"
                                            @input="addRating($event, item.id_alumno)"
                                        ></v-rating>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            class="btn_style3"
                            dark
                            
                            @click="$emit('close')"
                            >Cancelar</v-btn
                        >
                        <v-btn
                            class="btn_block_style2"
                            dark
                            
                            @click="saveItem"
                            >Guardar</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>

        <!-- end de formulario de actividades  -->
    </div>
</template>

<script>
import axios, { API_URL } from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";

//import ModalCrearActividades from './CrearActividad.vue'

export default {
    name: "ParticipacionClase",

    props: ["datosClase", "modalParticipacion"],

    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { id_submodulo: 26, id_modulo: 7 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        ////////////////////////////

        AlumnosSeccion: [],
        Participaciones: [],

        rating: {},

        parametrosAsistencia: [],

        headers: [
            /* { text: 'INDEX', align: 'left', value: 'index', class:'secondary'},
                { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
            {
                text: "N.°  DOCUMENTO DE IDENTIDAD",
                value: "numdoc_persona",
                class: "secondary black--text",
            },
            {
                text: "APELLIDOS Y NOMBRES",
                value: "nombre_apellido",
                class: "secondary black--text",
            },
            {
                text: "PUNTUACIÓN",
                value: "puntuacion",
                class: "secondary black--text",
            },
        ],

        ruta_api: API_URL + "/", // ruta del servidor
        //ruta_api: 'http://localhost:5000/' , // ruta del servidor

        //////////////////////////////////////
    }),

    computed: {
        ...mapGetters("login", ["componenteEvento"]),
    },

    mounted() {
        this.loadMain();
    },

    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations("mensajeSis", ["setEnviarMens"]),

        //----- Validar accesos por perfil ------------
        ...mapActions("login", ["parametroComponente"]),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente);
        },
        ////////////////////////////////////////////////////////
        addRating($event, id_alumno) {
            this.rating[id_alumno] = $event;
        },
        //  ------- Cargar todos los registros principales al iniciar el componente   --------
        async loadMain() {
            this.limpiarFormAct();
            try {
                let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/programacion/${this.datosClase.id_programacion}/seccion/${this.datosClase.id_seccion}/usuario/${this.datoLogin.id}`;
                let response = await axios.get(
                `/academico/participacion/crearParticipacion${params}`
                );   
                
                let data = response.data
                this.AlumnosSeccion = data.AlumnosSeccion
                this.Participaciones = data.Participacion

                this.Participaciones .forEach(item => {
                    this.rating[`${item.id_alumno}`] = item.puntuacion
                });

                if (data.mensaggeT == "E") {
                this.setEnviarMens({
                    tipo: data.mensaggeT,
                    mensaje: data.mensagge,
                    tiempo: null,
                });
                }                
            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: e, tiempo: null });
            }
        },

        async saveItem() {
            try {
                let res = await axios.post("/academico/participacion/", {
                    id_colegio: this.datoLogin.id_colegio,
                    id_periodo: this.datoLogin.id_ano_lectivo,
                    id_programacion: this.datosClase.id_programacion,
                    id_seccion: this.datosClase.id_seccion,
                    puntuaciones: JSON.stringify(this.rating),
                });

                this.setEnviarMens({
                    tipo: res.data.messageT,
                    //mensaje: res.data.message,
                    mensaje: "Felicitaciones Puntaje Obtenido",
                    tiempo: null,
                });
                //this.loadMain();
                this.$emit("close");
            } catch (error) {
                this.setEnviarMens({
                    tipo: "E",
                    mensaje: `${error}`,
                    tiempo: null,
                });
            }
        },

        limpiarFormAct() {
            /*this.parametrosAsistencia = {
        id_prog_docente: this.datosProgDocente.id,
        id_usuario: this.datoLogin.id,
        id_nivel: this.datosProgDocente.id_nivel,
        id_grado: this.datosProgDocente.id_grado,
      };*/
        },
    },
};
</script>
